import Modal from "react-bootstrap/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { Button, CircularProgress } from "@mui/material";

const ModalLayout = ({ children, isOpen, onConfirm, onCancel, title }) => {
  const [submitting, setSubmitting] = useState(false);
  const handleConnfirm = async () => {
    setSubmitting(true);
    await onConfirm();
    setSubmitting(false);
  };
  return (
    <>
      <Modal
        show={isOpen}
        onHide={onCancel}
        size="lg"
        className=""
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          style={{
            background: `url(${process.env.PUBLIC_URL}/images/model/reset.png)  no-repeat`,
            height: "200px",
          }}
        >
          <div>
            <CloseIcon
              className="cross"
              style={{
                position: "absolute",
                top: "2px",
                right: "2px",
                cursor: "pointer",
                fontSize: "40px",
                fontWeight: "bold",
                borderRadius: "40px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
              }}
              onClick={onCancel}
            />
          </div>

          <Modal.Title
            id="contained-modal-title-vcenter"
            className="w-100 text-right text-"
            style={{
              fontSize: "62px",
              fontWeight: "bold",
              textShadow: "rgba(32, 25, 24, 39.5) 0pc -5px 3px",
            }}
          >
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-dark text-center  relative ">
          {children}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center sm:!p-2 !p-0">
          <button
            className="btn btn-secondary me-2"
            disabled={submitting}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            disabled={submitting}
            onClick={handleConnfirm}
          >
            {submitting ? "Submitting..." : "Confirm"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalLayout;
